import { Chip, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  chip: {
    height: 18,
    fontSize: 12,
    fontWeight: 'bold',
  },
  active: {
    color: '#24C746',
    backgroundColor: '#DFFFE6',
  },
  inactive: {
    backgroundColor: '#F5F5F5',
    color: '#3C3C43',
  },
}));

const SubUserStatus = (props) => {
  const { record } = props;

  const classes = useStyles();

  return (
    <Chip
      className={classNames(classes.chip, record.enabled ? classes.active : classes.inactive)}
      label={record.enabled ? 'Active' : 'Inactive'}
    />
  );
};

export default SubUserStatus;
